export enum AudienceRuleType {
    Rule = 'rule',
    RuleSet = 'ruleSet',
}
